import { Box, Button, Flex, Text } from "@chakra-ui/react";
import Link from "next/link";

export const ClientFeatureBox = ({
  title,
  name,
  description,
  bg,
  bgColor = "brand.1000",
  color = "brand.100",
}: {
  title?: string;
  name: string;
  description: string;
  bgColor?: string;
  bg?: string;
  color?: string;
}) => {
  return (
    <Flex
      direction="column"
      bgColor={bgColor}
      bg={bg}
      color={color}
      flex={1}
      rounded="12px"
      p={4}
    >
      <Box flex={1} mb={4}>
        {!!title && <Text mb={4}>{title}</Text>}
        <Text fontWeight={700} fontSize={"20px"} mb={2}>
          {name}
        </Text>
        <Text dangerouslySetInnerHTML={{ __html: description }}></Text>
      </Box>
      <Link href="/sign-up?role=client">
        <Button variant="primary">Sign up</Button>
      </Link>
    </Flex>
  );
};
